// extracted by mini-css-extract-plugin
export default {"progressBar":"ats-title-progress_progressBar__IcxjE","fadeIn":"ats-title-progress_fadeIn__c-Lvw"};